
$( document ).ready(function() {

	function photoSwipe(idx){
	    var pswpElement = document.querySelectorAll('.pswp')[0];

	    // build items array
	    var items=[];
	    $('.image_swiper').each(function(key,item){

	        items.push({
	            src:item.href,
	            w:800,
	            h:800
	        });
	    });

	    // define options (if needed)
	    var options = {
	        // optionName: 'option value'
	        // for example:
	        index: idx // start at first slide
	    };
	    
	    // Initializes and opens PhotoSwipe
	    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
	    gallery.init();
	}   

	$('.image_swiper').click(function(e){
	    e.preventDefault();
	    idx = $(this).data('idx');
	    photoSwipe(idx);
	});

	////////////////////////////////////////////////////////////////////////////////////////////////
	//////////// Adding the needed links to the top, bottom per page lists ////////////////////////
	///////////////////////////////////////////////////////////////////////////////////////////////
	
	$('.items_per_page_selector').change(function(){
		//display the loader
		showLoader();
		//then redirect to the change function
		window.location.href = base_url+'/change_number_of_articles_per_page/per_page/'+$(this).val();
	});

	//////////////////////////////////////////////////
	/****** Lightbox trigger for side menus ********/
	////////////////////////////////////////////////

	$('.side_thumb').click(function(e){
		e.preventDefault();
		//scroll
	   scrollToAnchor('tabs');
	   //then switch tabs
	   $('.gallery_images_button').trigger('click');
	});
		


	///////////////////////////////////////////
	/************** star rating **************/
	///////////////////////////////////////////
	if ($(".rating_stars")[0]){
		$('.rating_stars').raty({ 
			starType: 'i',
			readOnly:true,
			half:true,
			score: function() {
	                      return $(this).attr('data-rating');
	                     }
		});
	}


	///////////////////////////////////////////
	/*************** FB share ****************/
	///////////////////////////////////////////
	$('.case_study_fb_share').click(function(e){
		e.preventDefault();
		href  = $(this).data('href');
		social_click(600, 450,href,'fb',null,null);
	});

	$('.case_study_tw_share').click(function(e){
		e.preventDefault();
		href  = $(this).data('href');
		social_click(600, 450,href,'tw',null,null);
	});

	$('.case_study_pt_share').click(function(e){
		e.preventDefault();
		href  = $(this).data('href');
		media = $(this).data('media');
		desc = $(this).data('desc');
		social_click(600, 450,href,'pt',media,desc);
	});

	/**************** video gallery plugin initialization *****************/
	if ($("#video-gallery")[0]){
		$('#video-gallery').royalSlider({
			    arrowsNav: false,
			    fadeinLoadedSlide: true,
			    controlNavigationSpacing: 0,
			    controlNavigation: 'thumbnails',
			    autoHideControlNav:true,
			    fullscreen: {
			    		// fullscreen options go gere
			    		enabled: true,
			    		native: true
			    },
			    thumbs: {
			      autoCenter: false,
			      fitInViewport: true,
			      orientation: 'vertical',
			      spacing: 0,
			      paddingBottom: 0
			    },
			    keyboardNavEnabled: true,
			    imageScaleMode: 'fill',
			    imageAlignCenter:true,
			    slidesSpacing: 0,
			    loop: false,
			    loopRewind: true,
			    numImagesToPreload: 3,
			    video: {
			      autoHideArrows:true,
			      autoHideControlNav:false,
			      autoHideBlocks: true
			    }, 
			    autoScaleSlider: true, 
			    autoScaleSliderWidth: 960,     
			    autoScaleSliderHeight: 450,
			    imgWidth: 640,
			    imgHeight: 360
			
			  });
	}
	/****************** fix video player shrink problem *****************/
		$('.tabs').bind('easytabs:before',function(){
			$('.royalSlider').hide();
		});
		
		$('.tabs').bind('easytabs:after',function(){
			$('.royalSlider').royalSlider('updateSliderSize', true);
			$('.royalSlider').slideDown('slow');
		});

	//when any of the side images is clicked 
	//switch to the gallery image tab then scroll to this place
	$(".scroll_to_gallery").click(function(e) {
		//prevent normal behavior
		e.preventDefault();
		//scroll
	   scrollToAnchor('tabs');
	   //then switch tabs
	   $('.gallery_images_button').trigger('click');
	});

});


//scroll to anchor function
	function scrollToAnchor(aid){
	    var aTag = $("a[name='"+ aid +"']");
	    $('html,body').animate({scrollTop: aTag.offset().top},'slow');
	}


//facebook share to open in a pop_up
function social_click(width, height,href,type,media,desc) {
    var leftPosition, topPosition;
    //Allow for borders.
    leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
    //Allow for title and status bars.
    topPosition = (window.screen.height / 2) - ((height / 2) + 50);
    var windowFeatures = "status=no,height=" + height + ",width=" + width + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";
    u=href;
    t=document.title;
    if(type=='fb'){
    	window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(u)+'&t='+encodeURIComponent(t),'sharer', windowFeatures);
    }else if(type=='tw'){
    	window.open('https://twitter.com/intent/tweet?url='+encodeURIComponent(u),'sharer', windowFeatures);
    }else if(type=='pt'){
    	window.open('//pinterest.com/pin/create/link/?url='+encodeURIComponent(u)+'&description='+desc+'&media='+media,'sharer', windowFeatures);
    }
    return false;
}